import {
  Button,
  Checkbox // Importamos Checkbox
  ,













  Modal,
  Steps
} from "antd";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { getInvoicesByStatus } from "../../../lib/getInvoicesByStatus";
import { updateInvoiceStatus } from "../../../lib/updateInvoiceStatus";
import AsignPercent from "./wizardSteps/AsignPercent";
import InvoicePreview from "./wizardSteps/InvoicePreview";
import PickEmployee from "./wizardSteps/PickEmployee";

const ModalManageEmployee = ({
  show,
  setShow,
  selectedCompany,
  selectedEmployees,
  setSelectedEmployees,
  selectedInvoice,
  setListOfInvoices
}) => {
  const notifyAccepted = (companyName) => {
    toast.success(
      `✔️ Factura aceptada, se enviará un email a ${companyName} notificando.`,
      {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
      }
    );
  };

  const [current, setCurrent] = useState(0);
  const [necesaryData, setNecesaryData] = useState({});
  const [advanceFlag, setAdvanceFlag] = useState(false);
  const [interesFlag, setInteresFlag] = useState(true); // Nuevo estado para el checkbox

  const next = () => {
    setCurrent(current + 1);
  };
  const prev = () => {
    setCurrent(current - 1);
  };

  const steps = [
    {
      title: "Seleccione los empleados",
      content: (
        <PickEmployee
          selectedInvoice={selectedInvoice}
          setSelectedEmployees={setSelectedEmployees}
          setAdvanceFlag={setAdvanceFlag}
        />
      ),
    },
    {
      title: "Asignar porcentaje",
      content: (
        <AsignPercent
          selectedEmployees={selectedEmployees}
          setNecesaryData={setNecesaryData}
          setAdvanceFlag={setAdvanceFlag}
        />
      ),
    },
    {
      title: "Confirmar",
      content: (
        <InvoicePreview data={necesaryData} selectedInvoice={selectedInvoice} interesFlag={interesFlag}/>
      ),
    },
  ];
  const items = steps.map((item) => ({
    key: item.title,
    title: item.title,
  }));

  const contentStyle = {
    lineHeight: "260px",
    textAlign: "center",
    marginTop: 20,
  };

  return (
    <Modal
      destroyOnClose
      centered
      open={show}
      width={900}
      onCancel={() => setShow(false)}
      closable={false}
      footer=""
    >
      <div style={{ height: "90vh", overflowY: "auto", marginTop: "20px" }}>
        <Steps current={current} items={items} />
        <div style={contentStyle}>{steps[current].content}</div>
        {current < steps.length - 1 && advanceFlag && (
          <Button type="primary" onClick={() => next()}>
            Siguiente
          </Button>
        )}
        {current === steps.length - 1 && (
          <>
            {/* Checkbox para interesFlag */}
            <Checkbox
            checked={interesFlag}
              style={{ marginBottom: "16px", display: "block" }}
              onChange={(e) => setInteresFlag(e.target.checked)}
            >
              ¿Aplicar interés? (en caso que destilde el campo el interes sera 0% para esta factura)
            </Checkbox>
            <Button
              type="primary"
              onClick={async () => {
                const metaData = {
                  emailTo: selectedInvoice.company.email,
                  companyName: selectedInvoice.company.name,
                  invoiceNumber: selectedInvoice.invoiceNumber,
                };

                const { _id } = selectedInvoice;

                await updateInvoiceStatus(
                  _id,
                  {
                    status: "ACCEPTED",
                    motive: "",
                  },
                  interesFlag, // Pasar el nuevo parámetro
                  metaData,
                  necesaryData
                ).then((res) => {
                  if (res.data === "OK") {
                    setShow(false);
                    notifyAccepted(selectedInvoice.company.name);
                    getInvoicesByStatus("PENDING").then((res) => {
                      setListOfInvoices(res.data);
                    });
                  }
                });
              }}
            >
              Confirmar
            </Button>
          </>
        )}
        {current > 0 && (
          <Button
            style={{
              margin: "0 8px",
            }}
            onClick={() => prev()}
          >
            Volver
          </Button>
        )}
      </div>
    </Modal>
  );
};

export default ModalManageEmployee;
